import * as CONSTANTS from './constants';

export const initChat = (user) => ({
  type: CONSTANTS.INIT_CHAT,
  user,
});

export const setUnreadMessageCount = (count) => ({
  type: CONSTANTS.SET_UNREAD_MESSAGE_COUNT,
  count,
});

export const setChatId = (chatId) => ({
  type: CONSTANTS.SET_CHAT_ID,
  chatId,
});

export const messagesError = (error) => ({
  type: CONSTANTS.MESSAGES_ERROR,
  error,
});
